'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002423 from "./presto.-Login-Page-View$$anon$23.js";
import * as $j_presto$002etypes$0024$002dLogin$002dMode$0024 from "./presto.types$-Login-Mode$.js";
import * as $j_presto$002etypes$0024$002dSaml$002dId$0024 from "./presto.types$-Saml-Id$.js";
import * as $j_presto$002etypes$0024$002dSaml$002dName$0024 from "./presto.types$-Saml-Name$.js";
import * as $j_presto$002etypes$0024proto$0024$002dGet$002dProvider$002dResponse$0024 from "./presto.types$proto$-Get-Provider-Response$.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$22() {
  this.b7j = null;
  this.b7b = null;
  this.b7c = false;
  this.b7k = null;
  this.b7l = false;
  this.b7o = null;
  this.b7h = null;
  this.b7i = false;
  this.b7d = null;
  this.b7e = false;
  this.b7f = null;
  this.b7g = false;
  this.b7m = false;
  this.b7n = false;
  this.b7j = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.b7o = "GetProviderResponse";
}
export { $c_Lpresto_LoginPageView$$anon$22 as $c_Lpresto_LoginPageView$$anon$22 };
$p = $c_Lpresto_LoginPageView$$anon$22.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$22;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$22() {
}
export { $h_Lpresto_LoginPageView$$anon$22 as $h_Lpresto_LoginPageView$$anon$22 };
$h_Lpresto_LoginPageView$$anon$22.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.b7j;
});
$p.M = (function() {
  if ((!this.b7c)) {
    this.b7b = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.b7c = true;
  }
  return this.b7b;
});
$p.O = (function() {
  if ((!this.b7l)) {
    this.b7k = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.b7l = true;
  }
  return this.b7k;
});
$p.D = (function() {
  return this.b7o;
});
$p.t = (function() {
  if ((!this.b7i)) {
    this.b7h = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("type", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.b7i = true;
  }
  return this.b7h;
});
$p.N = (function() {
  if ((!this.b7e)) {
    this.b7d = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dLogin$002dMode$0024.$m_Lpresto_types$LoginMode$().cIN(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_presto$002etypes$0024$002dSaml$002dId$0024.$m_Lpresto_types$SamlId$().cIP())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_presto$002etypes$0024$002dSaml$002dName$0024.$m_Lpresto_types$SamlName$().cIQ())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.b7e = true;
  }
  return this.b7d;
});
$p.Q = (function() {
  if ((!this.b7g)) {
    this.b7f = new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002423.$c_Lpresto_LoginPageView$$anon$23();
    this.b7g = true;
  }
  return this.b7f;
});
$p.v = (function() {
  if ((!this.b7n)) {
    this.b7m = false;
    this.b7n = true;
  }
  return this.b7m;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee148) => ((p) => \u03b4scrutinee148.cHP(p)))($j_presto$002etypes$0024proto$0024$002dGet$002dProvider$002dResponse$0024.$m_Lpresto_types$proto$GetProviderResponse$())));
});
var $d_Lpresto_LoginPageView$$anon$22 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$22, "presto.LoginPageView$$anon$22", ({
  Mm: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_LoginPageView$$anon$22 as $d_Lpresto_LoginPageView$$anon$22 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$22.js.map
